import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22fonts.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22../../public/fonts/lato-light.woff2%22,%22weight%22:%22300%22,%22style%22:%22normal%22},{%22path%22:%22../../public/fonts/lato-regular-ext.woff2%22,%22weight%22:%22400%22,%22style%22:%22normal%22},{%22path%22:%22../../public/fonts/lato-bold-ext.woff2%22,%22weight%22:%22700%22,%22style%22:%22normal%22}],%22declarations%22:[{%22prop%22:%22font-family%22,%22value%22:%22Lato%22},{%22prop%22:%22unicode-range%22,%22value%22:%22U+0100-024F,%20U+0259,%20U+1E00-1EFF,%20U+2020,%20U+20A0-20AB,%20U+20AD-20CF,%20U+2113,%20U+2C60-2C7F,%20U+A720-A7FF%22}],%22preload%22:false,%22variable%22:%22--font-lato-latin-ext%22}],%22variableName%22:%22latoLatinExt%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'latoLatinExt', 'latoLatinExt Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
